// extracted by mini-css-extract-plugin
module.exports =  {"content":"_93444fe79c--content--ruefw","text":"_93444fe79c--text--pzjxn","link":"_93444fe79c--link--Z_4h7"};